var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Component, Vue } from 'vue-property-decorator';
import { mixpanelTracking } from '@/services/mixpanel';
import { connect } from '@/overmind';
let default_1 = class extends Vue {
    handleGoSearch() {
        this.$router.push('/search');
    }
    mounted() {
        mixpanelTracking('upgrade 2.0: compra pelo cartão realizada com sucesso');
    }
};
default_1 = __decorate([
    Component(connect({
        name: 'PaymentSuccessCard',
        components: {},
    }))
], default_1);
export default default_1;
